<template>
  <div>

    <div class="container-fluid" style="margin-top:0">
      <div class="row-fluid">
        <!--最新活动-->
        <!-- <div class="row">
          <div class="col-12">
            <img src="https://img.hsnms.com/20210825/1629854034.webp" width="100%">
          </div>
        </div> -->
        <div class="span12 text-left" style="margin-top:20px">
          <div class="jumbotron bg1" style="margin-bottom:0;height:120px;padding:2.5rem 2rem">
            <div class="container">
              <div class="row">
                <div class="col-2 middle" style="margin-top:3px;margin-left:-10px">
                  <img :src=img width="50" height="50" />
                </div>
                <div class="col-6">
                  <div style="margin-left: 25px;">
                    <h4 style="color:#fffdff;">{{name | name}}</h4>
                  </div>
                  <div style="margin-left: 25px;color:#fffdff;">{{integral}} 积分</div>
                </div>
                <div class="col-4 text-right middle" @click="$router.push('/user_order_list')">
                  <span class="label label-default" style="padding: .5em .6em .3em;">我的订单</span>
                </div>
              </div>
            </div>
          </div>

          <div class="tt_10 tt_x_10">
            <h4>积分产品</h4>
          </div>
          <div class="row">

            <div class="cent" v-if="list == ''">
              暂无可兑换的产品
              <!-- <div class="jumbotron1  text-left" style="padding:0px; background-color:#FFFFFF;">
                <div class="text-center"><img src="https://img.hsnms.com/20210818/1629216285.jpg" width="90%"></div>
                <div>人工智能测试血压仪</div>
                <div class="text-warning t_5"><span class="glyphicon glyphicon-ok-circle"></span> 5021</div>
              </div> -->
            </div>

            <div class="col-6" v-for="(item,index) in list" :key="index" v-else @click="route(item.id)">
              <div class="jumbotron1  text-left" style="padding:0px; background-color:#FFFFFF;">
                <div class="text-center"><img :src=item.imgages_sma_a width="90%"></div>
                <div style="margin-top:0.5rem">{{item.title}}</div>
                <div class="text-warning t_5"><span class="glyphicon glyphicon-ok-circle"></span> {{item.integral}}
                </div>
              </div>
              <div style="height:20px;"></div>
            </div>
            <!-- <div class="col-6">
              <div class="jumbotron1  text-left" style="padding:0px; background-color:#FFFFFF;">
                <div class="text-center"><img src="https://img.hsnms.com/20210818/1629216285.jpg" width="90%"></div>
                <div>人工智能测试血压仪</div>
                <div class="text-warning t_5"><span class="glyphicon glyphicon-ok-circle"></span> 5021</div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
      <div v-if="list != ''">
        <button v-if="moreShowBoolen" @click="moreShow1" class="btn_page btn1"
          style="display:block;margin:25px auto 0;outline: none; color: #666; background-color: #eee; border-radius: 25px; height: 30px; width: 60%;">更多选项</button>
        <div v-else style="text-align:center;margin-top:15px">已无更多</div>
      </div>
      <div id="d_p"></div>
    </div>

  </div>
</template>

<script>
import user_model from '../tool/user_model'
export default {
  data () {
    return {
      list: [],
      img: '',
      name: '',
      integral: '',
      nowPage: 1,
      moreShowBoolen: false,
      nowPage_t: 1
    }
  },
  components: {},
  props: {},
  created () { },
  mounted () {
    this.moreShow1()
    // const info = user_model.getUserinfo()
    // this.$api.getAPI("data/product/?appid=202108&type_id=9001&state=1&size=100", {}).then(res => {
    //   this.list = res.data.data.data[0].models
    // })
    // this.$api.getAPI("mutual/attribute/id?appid=202108&type_id=4001", {
    //   openid: info.openid
    // }).then(res => {
    //   // console.log(res.data.data.models);
    //   this.img = res.data.data.models.avatar_url
    //   // console.log(this.img);
    //   this.name = res.data.data.models.username
    //   this.integral = res.data.data.models.integral
    // })
  },
  methods: {
    moreShow1 () { // 点击查询更多
      const info = user_model.getUserinfo()
      this.img = info.avatar_url
      this.name = info.username
      this.integral = info.integral
      this.$api.getAPI("data/product/?appid=202108&type_id=9001&state=1&size=10", {
        page: this.nowPage
      })
        .then(res => {
          for (let i = 0; i < res.data.data.data[0].models.length; i++) {
            this.list.push(res.data.data.data[0].models[i])
          }
          var db = res.data.data.data[0];
          this.nowPage_t = db.page.count;
          this.moreShowBoolen = true
          if (this.nowPage_t < (this.nowPage * 10)) {
            this.moreShowBoolen = false
          }
          this.nowPage++;
        })
    },
    route (id) {
      // @click="$router.push('/mall_show')"
      // console.log(id);
      this.$router.push({
        name: 'mall_show',
        query: {
          id: id
        }
      })
    }
  },
  filters: {
    name (value) {
      if (!value) return '';
      let str = value;
      str = str.toString().replace(/^([^\x00-\xff])([^\x00-\xff]{0,})([^\x00-\xff])/g, '$1*$3')
      return str;
    }
  }


}
</script>

<style>
.cent {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #777;
  font-size: 20px;
}
.btn1 {
  border: none;
  outline: 0;
  background: none;
}
.bj_show {
  background: #01b2c2;
  height: 12rem;
}

.container-fluid-a {
  position: absolute;
  top: 10px;
}

.bj_show .jumbotron1 {
  padding: 2rem 2rem;
  margin-bottom: 2rem;
}

.bg1 {
  background: url("https://img.hsnms.com/20210922/1632279215.jpg") no-repeat
    center;
  background-size: 100% 100%;
  /* box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.4); */
}

.jumbotron1 {
  padding-right: 15px;
  padding-left: 15px;
  border-radius: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/views/mall_list.vue